import { appLogger } from "../logger";

export const chartHighlighter = (
  selectedDataPoints: number[],
  wrapperElem: HTMLElement | null,
  chartType: "pie" | "bar"
) => {
  if (wrapperElem) {
    let col: HTMLCollectionOf<Element> | null = null;
    if (chartType === "pie") {
      col = wrapperElem.getElementsByClassName("apexcharts-slices");
    } else {
      col = wrapperElem.getElementsByClassName("apexcharts-series");
    }

    let graphSlices: HTMLCollection | null = null;
    if (col.length > 0) {
      graphSlices = col[0].children;
    }

    if (graphSlices) {
      for (let i = 0; i < graphSlices.length; i++) {
        let slice: SVGElement | null;
        if (chartType === "pie") {
          slice =
            graphSlices[i].children.length > 0
              ? (graphSlices[i].children[0] as SVGElement)
              : null;
        } else {
          slice = graphSlices[i] as SVGElement;
        }

        if (!slice || slice.tagName.toLowerCase() !== "path") {
          continue;
        }

        if (selectedDataPoints && selectedDataPoints.includes(i)) {
          const fillColor = slice.getAttribute("fill");
          if (fillColor) {
            slice.style.stroke = fillColor;
            slice.style.fillOpacity = "0.7";
            slice.style.filter = "none";
            if (!slice.getAttribute("selected"))
              slice.setAttribute("selected", "true");
          } else {
            slice.style.stroke = "#111";
            slice.style.fillOpacity = "0.7";
            slice.style.filter = "none";
            if (!slice.getAttribute("selected"))
              slice.setAttribute("selected", "true");
          }
        } else {
          slice.style.stroke = "";
          slice.style.fillOpacity = "1";
        }
      }
    }
  }
};
